import React, { useMemo, useState } from 'react';
import {
  MobileGameStructure,
  MobileGameWr,
  SidebarHolder,
} from '@pascal/pascal-core/table-line/table-components';
import {
  DefaultQueryParams,
  GameControllers,
  iframeService,
  parseQuery,
  RightSideHolder,
  useTranslation,
  tableBetHistoryStore,
  MobileStructureMiddle,
} from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { GAME_CONTROLLER_TYPES } from '@pascal/pascal-core/shared/core/enums/gameControllerTypes';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { applicationStore as applicationStoreCore } from '@pascal/pascal-core/shared/core/store/applicationStore';
import MobileGameContent from '../components/mobileGameContent';
import Help from '../components/help';
import { BetHistoryWr } from '../components/betHistory';
import { SettingsContainer } from '../components/settings';
import LimitAndPayouts from '../components/limitsAndPayouts';
import { userInfoStore } from '../store/userInfoStore';
import { TranslationKeys } from '../core/constants/translationKeys';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../core/constants/betResponseCodes';
import { applicationStore } from '../store/applicationStore';

const gameControllerComponents = {
  [GameControllerTypes.Help]: <Help />,
  [GameControllerTypes.History]: <BetHistoryWr />,
  [GameControllerTypes.Settings]: <SettingsContainer />,
  [GAME_CONTROLLER_TYPES.PAYOUTS_AND_LIMITS]: <LimitAndPayouts />,
};

function Mobile() {
  const { search } = useLocation();
  const { [DefaultQueryParams.UserId]: userId } = parseQuery(search);
  const [gameControllerType, setGameControllerType] = useState('');
  const { selectedHistoryRow, setSelectedHistoryRow } = tableBetHistoryStore;
  const { currencyCode } = userInfoStore;
  const t = useTranslation();
  const { isTestPlatform } = applicationStoreCore;
  const { isDemo, hasRealModeSwitcher } = applicationStore;

  const navigationItems = useMemo(() => {
    return [
      {
        icon: 'icon-home1',
        name: t(TranslationKeys.Home),
        onClick: () => iframeService.redirectHome(),
      },
      {
        icon: 'icon-history',
        name: t(TranslationKeys.History),
        isDisabled: !userId,
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY),
      },
      {
        icon: 'icon-info1',
        name: t(TranslationKeys.Rules),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HELP),
      },
      {
        icon: 'icon-settings',
        name: t(TranslationKeys.GameSettings),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.SETTINGS),
      },
    ];
  }, [userId, setGameControllerType, t]);

  const GameControllerComponent = useMemo(() => {
    const component = gameControllerComponents[gameControllerType];
    if (component) {
      return component;
    }
    return null;
  }, [gameControllerType]);

  return (
    <MobileGameWr>
      <MobileGameStructure>
        <MobileStructureMiddle
          haveNotification
          AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
          AdditionalResponseCode={AdditionalResponseCode}
          AdditionalErrorMessages={AdditionalErrorMessages}
        >
          <MobileGameContent
            isDemo={isDemo}
            hasRealModeSwitcher={hasRealModeSwitcher}
            isTestPlatform={isTestPlatform}
          />
          <SidebarHolder setGameControllerType={setGameControllerType}>
            <GameControllers
              currencyCode={currencyCode}
              controllerType={gameControllerType}
              setGameControllerType={() => setGameControllerType(null)}
              selectedHistoryRow={selectedHistoryRow}
              setSelectedHistoryRow={setSelectedHistoryRow}
              gameControllerComponent={GameControllerComponent}
              hasScrollToBottom={gameControllerType === GAME_CONTROLLER_TYPES.RESULTS}
            />
          </SidebarHolder>
          <RightSideHolder navigationItems={navigationItems} />
        </MobileStructureMiddle>
      </MobileGameStructure>
    </MobileGameWr>
  );
}
export default Mobile;
